import React, { Component } from 'react';
import { chunk } from 'lodash';

import { Flag, GenericStandingsTable, StandingsTableHeader, AdBanner } from '../../screens/components';
import {
  categories,
  imgUrl,
  pairs,
  firstColumnCenter,
  topScrorers,
  standingsMainTableSubtitle,
  singleTeamArrays,
  standingsTitle,
  corsMessage,
  chooseCompetition
} from '../../constants.js';

import './standings.scss';

let countTables = 0;

class Standings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: this.props.sportId
    };
    this.handleSelectCompetition = this.handleSelectCompetition.bind(this);
  }

  componentDidMount() {
    this.props.fetchStandings(this.props.sportId, this.props.clientId, this.props.productId);
  }

  normalizeData(data = []) {
    if (!Object.keys(data).length) {
      return {
        header: [],
        body: []
      };
    }

    const fields = data.fields;
    const fieldKeys = Object.keys(fields);

    const headerTitle = fieldKeys.map(k => fields[k]);

    return {
      header: [
        [...headerTitle],
        [{...fields}]
      ],
      body: data.data
    };
  }

  renderPairsTables(data1, data2) {
    if (!data1 || !data2 || !data1.data || !data2.data || !data1.data.data || !data2.data.data) return null;

    let cssClass = '';

    if (singleTeamArrays.indexOf(data1.key) !== -1) {
      cssClass = 'single-team';
    } else {
      cssClass = 'single-team-percentage';
    }

    return (
      <div key={data1.key} >
        <div className="standings-app-pairs">
          <GenericStandingsTable
            data={this.normalizeData(data1.data)}
            title={data1.data.label}
            firstConlumnTextAlign={firstColumnCenter.indexOf(data1.key) !== -1 ? 'center' : 'left'}
            className={cssClass}
          />
          <GenericStandingsTable
            data={this.normalizeData(data2.data)}
            title={data2.data.label}
            firstConlumnTextAlign={firstColumnCenter.indexOf(data2.key) !== -1 ? 'center' : 'left'}
            className={cssClass}
          />
        </div>
        {data1.isBannerVivible &&  <AdBanner html={this.props.adData} />}
      </div>
    );
  }

  createPairsOfData = (clients = {}) => {
    const pairTables = [];

    pairs.forEach(p => {
      if (clients[p] === 'true') {
        const chunks = chunk(categories[p], 2);
        pairTables.push(
          chunks.map((tableName, i) => {
            countTables += 2;
            const isBannerVivible = countTables % 4 ===0;;
            return this.renderPairsTables(
              { key: tableName[0], data: this.props.standingsData && this.props.standingsData[tableName[0]] && this.props.standingsData[tableName[0]], isBannerVivible },
              { key: tableName[1], data: this.props.standingsData && this.props.standingsData[tableName[1]] && this.props.standingsData[tableName[1]] }
            );
          })
        );
      }
    });

    return pairTables;
  }

  addTeamFlagUrlToData(data) {
    return data.map(d => {
      return {
        ...d,
        teamId: imgUrl(d.teamId)
      };
    });
  };

  normalizeStandingsData = (standings, standing, client) => {
    const fields = standings[standing].fields;
    const tmpBody = this.addTeamFlagUrlToData(standings[standing].data);
    const subFields = [];
    const penaltyPts = [];
    const legend = [];

    const body = tmpBody.map((b, i) => {
      if (b.penalty_pts && b.penalty_pts !== '0') {
        penaltyPts.push({ [b.teamName]: b.penalty_pts });
      }

      if (b.info) {
        const hasIncluded = legend.filter(f => f.title === b.info.value);

        if (hasIncluded.length === 0) {
          legend.push({
            title: b.info.value,
            colorId: b.info.id
          });
        }

        return {
          ...b,
          className: `legend-${b.info.id}`
        };
      } else {
        return b;
      }
    });
    const headerFields = Object.keys(fields).map(f => {
      const value = fields[f];
      subFields.push(Object.keys(value.sub).map(subField => {return  {[subField]: value.sub[subField]}; }));
      return value.label;
    });

    return {
      header: [
        headerFields,
        subFields
      ],
      body,
      footer: {
        legend,
        penaltyPts,
        locale: client.locale
      }
    };
  }

  renderStandingsTable = (standings = {}, client = {}) => {
    if (Object.keys(standings).length === 0) return null;
    countTables += 4;

    return Object.keys(standings).map((standing, i) => {
      const isAdVisible = countTables % 4 ===0;

      return (
        <div key={`${i}tstant`}>
          <GenericStandingsTable
            data={this.normalizeStandingsData(standings, standing, client)}
            hasSubHeader
            title={standing}
            subtitle={standingsMainTableSubtitle[client.locale]}
            hasBorder
            isAsteriskVisible
            className="standings-app-main-standings"
          />
          {
            isAdVisible &&  <AdBanner html={this.props.adData} />
          }
        </div>
      );
    });
  }

  renderTopScorers = (scorers = {}, client = {}) => {
    if (Object.keys(scorers).length === 0) return null;
    countTables += 2;

    const key = Object.keys(scorers)[0];
    if (!scorers[key]) return null;

    const newScorers = {
      ...scorers[key],
      data: this.addTeamFlagUrlToData(scorers[key].data)
    };

    return (
      <GenericStandingsTable
        data={this.normalizeData(newScorers)}
        title={topScrorers[client.locale]}
        subtitle={key}
        className="standings-app-top-scorers"
      />
    );
  }

  renderHalves(halves = {}, client = {}) {
    const labels = Object.keys(halves || {});
    if (labels.length === 0) return null;

    return labels.map((half, i) => {
      countTables += 2;
      return (
        <div key={`${i}tstant`}>
          <GenericStandingsTable
            data={this.normalizeStandingsData(halves, half, client)}
            hasSubHeader
            title={half}
            subtitle={standingsMainTableSubtitle[client.locale]}
            hasBorder
            className="standings-app-halves"
          />
          { countTables % 4 === 0 && <AdBanner html={this.props.adData} />}
        </div>
      );
    });
  }

  renderLeagueStats(leagueStats) {
    if (!leagueStats || Object.keys(leagueStats).length === 0) return null;
    countTables += 2;
    return (
      <div>
        <GenericStandingsTable
          data={this.normalizeData(leagueStats)}
          title={leagueStats.label}
          firstConlumnTextAlign="left"
          className="standings-app-league"
        />
        { countTables % 4 === 0 && <AdBanner html={this.props.adData} />}
      </div>
    );
  }

  renderTotalStats(stats, client = {}) {
    if (!stats || Object.keys(stats).length === 0) return null;
    countTables += 2;
    return (
      <div>
        <GenericStandingsTable
          data={this.normalizeData(stats)}
          title={stats.label}
          className="standings-app-total-stats"
        />
        { countTables % 4 === 0 && <AdBanner html={this.props.adData} /> }
      </div>
    );
  }

  renderDropdownOptions(standingsCompetitions = []) {
    return standingsCompetitions.map((comp, i) => {
      const hasWbsFeed = this.props.client.has_wbs_feed;

      if (hasWbsFeed && hasWbsFeed !== '0') {
        return <option key={`${comp.id}{i}`} value={comp.slug}>{comp.name}</option>;
      }
      return <option key={`${comp.id}{i}`} value={comp.id}>{comp.name}</option>;
    });
  }

  renderFlags(standingsCompetitions = [], handleClick) {
    return standingsCompetitions.map((f, i) => {
      let title = `${standingsTitle[this.props.client.locale]} ${f.name}`;

      if (this.props.client.locale ==='en') {
        title = `${f.name} ${standingsTitle[this.props.client.locale]}`;
      }
      return(
        <Flag
          onClick={handleClick}
          key={`${f.flag}${i}`}
          flagName={f.competitionNumber}
          slug={f.slug}
          id={f.id}
          flagFileName={f.flag}
          title={title}
          hasWbsFeed={this.props.client.has_wbs_feed}
        />
      );
    });
  }

  // Reload the page with the new slug
  handleSelectCompetition(selectedValue) {
    const hasWbsFeed = this.props.client.has_wbs_feed;

    if (hasWbsFeed && hasWbsFeed !== '0') {
      window.location.href = `/${selectedValue}`;
    } else {
      this.setState({ id: selectedValue },this.props.fetchStandings(selectedValue, this.props.clientId,  this.props.productId));
    }
  }


  renderLoader() {
    return (
      <div className="standings-app-loader-container">
        <div className="standings-app-loader"></div>
      </div>
    );
  }

  renderTables = () => {
    return (
      <div>
        {this.props.standingsData && this.props.client && this.props.client.standings === 'true' && this.renderStandingsTable(this.props.standingsData.standings, this.props.client)}
        {this.props.standingsData && this.props.client && this.props.client.scorers === 'true' && this.renderTopScorers(this.props.standingsData.scorers, this.props.client)}
        {this.props.standingsData && this.props.client && this.props.client.teamTotalStats === 'true' && this.renderTotalStats(this.props.standingsData.teamTotalStats, this.props.client)}
        {this.props.standingsData && this.props.client && this.props.client.halves === 'true' && this.renderHalves(this.props.standingsData.halves, this.props.client)}
        {this.props.standingsData && this.props.client && this.props.client.leagueStats === 'true' && this.renderLeagueStats(this.props.standingsData.leagueStats, this.props.client)}
        {this.props.standingsData && this.props.client && this.createPairsOfData(this.props.client)}
      </div>
    );
  }

  renderTitle(standingCompetition, firstStandingsTeamName) {
    const isLoading = this.props.isLoading;
    let name;

    if (isLoading) return null;

    if (standingCompetition) {
      name = standingCompetition.name;
    } else {
      name = firstStandingsTeamName;
    }

    return (
      <h1 className="standings-app-title">
        {`${standingsTitle[this.props.client.locale] || ''} ${name || ''}`}
      </h1>
    );
  }

  render() {
    const standingCompetition = this.props.client.standingsCompetitions.filter(sc => sc.id === this.state.id)[0];
    const standingsCompetitions = this.props.client.standingsCompetitions;
    const firstStandingsTeamName = standingsCompetitions[0] ? standingsCompetitions[0].name : null;

    if(!this.props.isAuthorized) {
      return <div className="standings-app-cors-message">{corsMessage.el}</div>;
    }

    return (
      <div className="standings-app">
        <div className="standings-app-dropdown-container">
          <StandingsTableHeader
            withCaret={false}
            title={chooseCompetition[this.props.client.locale]}
            textAlign="left"
            className="standings-app-dropdown-container-header"
          />
          <select
            className="standings-app-flags-dropdown"
            onChange={e => this.handleSelectCompetition(e.target.value)}
          >
            {this.renderDropdownOptions(standingsCompetitions)}
          </select>
        </div>
        <div className="standings-app-flags-container">
          {this.renderFlags(standingsCompetitions, this.handleSelectCompetition)}
        </div>
        {this.renderTitle(standingCompetition, firstStandingsTeamName)}
        <div className="standings-app-tables-container">
          {this.props.isLoading ? this.renderLoader() : this.renderTables()}
        </div>
        {
          this.props.client.textlink ? (
            <div className="standings-app-text-link" dangerouslySetInnerHTML={{__html: this.props.client.textlink}}></div>
          ) : null
        }
      </div>
    );
  }
}

Standings.propTypes = {
};

export default Standings;







// WEBPACK FOOTER //
// ./src/screens/standingsScreen/Standings.jsx